/* globals axios */
import Vue from 'vue';

Vue.component('cookie-declaration', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            //
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        // Inject horrible cookiebot stuff.
        const placeholder = document.getElementById('CookieDeclarationPlaceholder');

        if (placeholder) {
            const cookieBot = document.createElement('script');
            cookieBot.id = placeholder.getAttribute('data-id');
            cookieBot.setAttribute('src', placeholder.getAttribute('data-src'));
            cookieBot.async = true;

            placeholder.parentNode.appendChild(cookieBot);
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios.post('/', new FormData(form))
            .then((response) => {
                this.submitting = false;
                if (response.data.errors) {
                    this.errors.clear();

                    this.errors.record(response.data.errors);
                    return;
                }

                // Success
                this.formCompleted = true;
                this.errors.clear();
            })
            .catch((error) => {
                this.submitting = false;
                console.log(error);
            });
        },
    },
});
